// This file is generated by pnpm icons:generate. Do not edit.

import {CircleInfo_Stroke2_Corner0_Rounded as CanonicalCircleInfo_Stroke2_Corner0_Rounded} from './Circle'

/** @deprecated Import CircleInfo_Stroke2_Corner0_Rounded from `#/components/icons/Circle` instead. */
export const CircleInfo_Stroke2_Corner0_Rounded =
  CanonicalCircleInfo_Stroke2_Corner0_Rounded
